import { useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../store/actions/authActions';
import { useState } from 'react';
import { getContentKeyAccToLang, setToken } from '../../utils/utils';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();

  const dashboardContent = useSelector((state) => state.content?.dashboardContent);
  const user = useSelector((state) => state.content?.user);
  const applicationId = useSelector((state) => state.content?.applicationId);
  const { authLoading } = useSelector((state) => state.auth);

  const [confirmModal, setConfirmModal] = useState(false);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(dashboardContent, key, isArabic);
  };

  // const handleLogout = () => {
  //   if (!user) {
  //     dispatch(setAccountOpening({}))
  //     setToken("")
  //     navigate("/login")
  //   } else {

  //     dispatch(logoutUser(null, isArabic))
  //   }
  // };

  return { navigate, TextWeight, applicationId, confirmModal, setConfirmModal, authLoading, getContentKey, user };
};
